var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatspp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6483 22.6565C19.102 22.6565 16.5863 22.1016 14.1011 20.9918C11.6159 19.882 9.35479 18.3082 7.31775 16.2704C5.28071 14.2325 3.70731 11.9714 2.59753 9.48705C1.48775 7.00268 0.932455 4.48694 0.931641 1.93983C0.931641 1.57316 1.05386 1.26761 1.29831 1.02316C1.54275 0.778716 1.84831 0.656494 2.21497 0.656494H7.16497C7.45016 0.656494 7.70479 0.753457 7.92886 0.947383C8.15294 1.14131 8.28534 1.37027 8.32609 1.63427L9.12053 5.91205C9.16127 6.23798 9.15108 6.51298 9.08997 6.73705C9.02886 6.96112 8.91683 7.15464 8.75386 7.31761L5.78997 10.312C6.19738 11.0658 6.68097 11.7938 7.24075 12.4962C7.80053 13.1985 8.41694 13.876 9.08997 14.5287C9.72146 15.1602 10.3835 15.746 11.0761 16.2863C11.7687 16.8265 12.502 17.3203 13.2761 17.7676L16.1483 14.8954C16.3316 14.712 16.5712 14.5748 16.867 14.4835C17.1628 14.3922 17.4528 14.3666 17.7372 14.4065L21.9539 15.262C22.239 15.3435 22.4733 15.4914 22.6566 15.7057C22.84 15.92 22.9316 16.1592 22.9316 16.4232V21.3732C22.9316 21.7398 22.8094 22.0454 22.565 22.2898C22.3205 22.5343 22.015 22.6565 21.6483 22.6565Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatspp);
export default __webpack_public_path__ + "static/media/whatspp.3a881894f2cde703dac1bdadcc1e8689.svg";
export { ForwardRef as ReactComponent };